import { render, staticRenderFns } from "./EmbeddedInfo.vue?vue&type=template&id=b319e44e&scoped=true&"
import script from "./EmbeddedInfo.vue?vue&type=script&lang=js&"
export * from "./EmbeddedInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedInfo.vue?vue&type=style&index=0&id=b319e44e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b319e44e",
  null
  
)

export default component.exports